import "./FloatingTiles.css";

/**
 * Decorative floating rectangular tiles for use as a page background.
 * Renders animated semi-transparent rectangles that subtly float and rotate.
 */
export function FloatingTiles() {
  return (
    <div className="floating-tiles" aria-hidden="true">
      <div
        data-testid="bg-rect-lg"
        className="floating-tiles__rect floating-tiles__rect--lg"
      />
      <div
        data-testid="bg-rect-md"
        className="floating-tiles__rect floating-tiles__rect--md"
      />
      <div
        data-testid="bg-rect-sm"
        className="floating-tiles__rect floating-tiles__rect--sm"
      />
      <div
        data-testid="bg-rect-xs"
        className="floating-tiles__rect floating-tiles__rect--xs"
      />
    </div>
  );
}
